export const ErrorMessage = (props: { text: string, urgency: "critical" | "moderate" | "low" | "" }) => {
    switch (props.urgency) {
        case "critical":
            return (
                <label className='error-message-critical'>{props.text}</label>
            )
        case "moderate":
            return (
                <label className='error-message-moderate'>{props.text}</label>
            )
        case "low":
            return (
                <label className='error-message-low'>{props.text}</label>
            )
        default:
            return (
                <label>{props.text}</label>
            )
    }
}